module.exports = {
  message: {
    //Building
    sy: "首页",
    wzzzwh: "网站正在维护",
    //Bulletin
    gg: "公告",
    //BulletinArticle
    wzmc: "文章名称",
    fbsj: "发布时间",
    //DataPublic
    sjgk: "数据公开",
    fwgk: "服务公开",
    fwsl: "服务受理",
    ptlj: "平台累计",
    hswj: "回收问卷",
    j: "件",
    gzd3: "关注度TOP3",
    bjl: "办结率",
    mztb: "每周通报",
    sll: "受理量",
    ydtb: "月度通报",
    gfwmksl: "各服务板块受理量",
    kkjderdwlshm: "看看交大er都问了什么?",
    xh: "序号",
    fksj: "反馈时间",
    fknr: "反馈内容",
    fwfl: "服务分类",
    cbdw: "承办单位",
    //Evaluate
    fwlx: "服务类型",
    wypj: "我要评价",
    wjpj: "问卷评价",
    fwmk: "服务板块",
    xzfwmk: "请选择服务板块",
    fwfw: "服务范围",
    xzfwfw: "请选择对应的服务范围",
    fwqy: "服务区域",
    xzfwqy: "请选择对应的服务区域",
    cypj: "参与评价",
    //HistoryFeedback
    lsfk: "历史反馈",
    lsh: "流水号",
    cljc: "处理进程",
    blz: "办理中",
    fhz: "复核中",
    //Home
    swzl: "失物招领",
    xzbz: "寻找你丢失的宝藏",
    dzdt: "电子地图",
    jdmdd: "焦点你的目的地",
    txwjwshfwdf: "填写问卷为生活服务打分！",
    shsd: "随时随地倾听您的声音",
    ssp: "随手拍",
    benkexiuye: "本科修业导航",
    benkexiuyeinfo: "本科生学业指南",
    rrcy: "人人参与共建精致校园",
    zxkf: "在线客服",
    rgkfsj: "人工客服时间:8:30-17:00",
    yzscx: "一站式查询&评价办理情况",
    wdfk: "我的反馈",
    qnzs: "学联权益",
    xgwzms: "为青年发声，让美好发生！",
    ymlr: "服务数据一目了然",
    ggl: "公告栏",
    tjl: "提交了",
    fwfk: "服务反馈",
    jiedanliang: "接办量",
    slmyd: "受理满意度",
    gzd: "关注度",
    gradute: "研途有你",
    graduteinfo: "助力研究生学业与成长",
    // index
    dl: "登录",
    tc: "退  出",
    htdl: "后台登录",
    shfwrx: "服务热线",
    fdjjr: "法定节假日暂停服务",
    hjicp: "沪ICP备05052060号-1",
    bqsy: "版权所有©上海交通大学",
    dzshs: "地址: 上海市东川路800号",
    ybh: "邮编: 200240",
    ch: "查号",
    lalala1:
      "本平台仅为失物招领信息的公益发布及查询平台。请大家遵循诚信原则发布真实信息。 本平台对信息的真实性不承担任何法律责任，并保留删除任何违规信息的权利。由信息错误产生或可能产生的任何纠纷或损失，由各方协商解决。",
    // LostFind
    // addFindThing
    wdsl: "我丢失了",
    bt: "标题",
    srbt: "请输入标题",
    wplx: "物品类型",
    qxz: "请选择",
    dsxq: "丢失校区",
    bq: "标签",
    zdsr: "最多输入两个，如品牌、颜色、地点",
    dssj: "丢失时间",
    xzzqsj: "请选择一个比较准确的时间",
    dsdd: "丢失地点",
    srzqdd: "请输入一个比较准确的地点",
    zpsc: "照片上传",
    zfmzp: "添加说明：上传校园卡正反面照片",
    zd3z: "最多可上传3张",
    kzxgh: "卡主学工号",
    srxgh: "请输入学工号",
    lxfs: "联系方式",
    srndsjh: "请输入你的手机号",
    ly: "留言",
    wljkzh:
      "为了您的失物能尽快找回,建议提供相关图片。若无图片，请详细描述物品颜色、形状等",
    tj: "提交",
    swxxfbcg: "失物消息发布成功",
    ms: "描述",
    wpxzxq: "请选择",
    gxwk: "该项为空",
    fh: "返回",
    zltj: "招领推荐",
    zl: "招领",
    wxts: "温馨提示",
    lalala2:
      "平台已实名认证，请您基于诚信原则发布信息。请勿发布与失物无关的信息！由任何信息产生或可能产生的任何纠纷或损失，由各方协商解决。您所填信息仅向校内师生展示。期待您的宝贝尽快回来",
    zklyx: "再考虑一下",
    qrfb: "确认发布",
    // addWaitClaim
    wsdl: "我拾到了",
    fbzlxx: "发布招领信息",
    sqxq: "拾取校区",
    sqsj: "拾取时间",
    sqdd: "拾取地点",
    kzxm: "卡主姓名",
    hdxgh: "仅用于核对学工号是否正确",
    lalala3:
      "如需进一步描述拾取地点、存放地点、物品状态等，可向失主留言，留言公开可见。贵重物品请勿直接公开存放地点，避免他人冒领。可后续通过电话联系告知。感谢您的配合！",
    lalala4:
      "平台为jaccount实名认证，请您基于诚信原则发布信息。请勿发布与拾物无关的信息！由任何信息产生或可能产生的任何纠纷或损失，与本平台无关。您所填信息仅向校内师生展示。感谢您的拾金不昧！",
    // findInfo
    wfbdxx: "我发布的消息",
    wrldxx: "我认领的消息",
    xykh: "校园卡号",
    zp: "照片",
    zt: "状态",
    rlsj: "认领时间",
    qrsj: "确认时间",
    rlxx: "认领信息",
    rnwsz:
      "若您为失主，可通过联系方式直接联系拾取者。本平台为jaccount实名认证，请勿冒领",
    ghwpsqrszsf:
      "归还物品时，请确认失主身份，谨防冒领。如您已归还，请及时点击“物品已归还”。感谢您的拾金不昧！",
    rlgwp: "认领该物品",
    qxfb: "取消发布",
    wpygh: "物品已归还",
    qrrlh:
      "确认认领后，您将获得拾取者的联系方式，同时您的认领记录将在平台备案。请勿冒领",
    wyrl: "我要认领",
    schwfzh: "删除以后将无法找回，请慎重考虑是否删除发布的消息",
    qr: "确认",
    rlcc: "认领成功",
    fbrdsjhm: "发布人的手机号码为：",
    jklxsqz: "请尽快联系拾取者。",
    // findThing
    xzsw: "寻找失物",
    xz: "寻找",
    yzh: "已找回",
    // index
    wxgdxx: "我相关的消息",
    hcss: "请按回车搜索",
    hcssa: "请按回车搜索（反馈内容）",
    qc: "清除",
    ddrl: "等待认领",
    zsmynr: "暂时没有内容，期待你的第一条宝藏信息",
    sw: "失物",
    // lostInfo
    jydqgzptxx:
      "建议定期关注平台招领信息，寻找您丢失的宝藏！如您已找回，请及时点击“物品已找回”，谢谢配合",
    rnsdyswp:
      "若您拾到以上物品，可通过联系方式直接联系失主。平台为jaccount实名认证。",
    wpyzh: "物品已找回",
    wjdl: "我捡到了",
    qrcg: "确认成功",
    jklxsz: "请尽快联系失主。归还物品时别忘了确认失主身份哦",
    qrsqh:
      "确认拾取后，您将获得失主的联系方式，同时您的确认记录将在平台备案。感谢您的拾金不昧！",
    sd: "是的",
    // minePublishInfo
    nhmyfbxx: "你还没有发布过消息",
    // waitClaim
    // Online
    xzkf: "在线客服",
    fwjjsx: "服务即将上线",
    // ServicePublic
    // detail
    bjsj: "办结时间",
    bjhf: "办结回复",
    zyx: "赞一下",
    // index
    // ServiceType
    srsjh: "请输入手机号码",
    hqyzm: "获取验证码",
    sryzm: "输入验证码",
    qx: "取 消",
    qd: "确 定",
    // ShowData
    // Snapshot
    fklx: "反馈类型",
    xzfklx: "请选择反馈类型",
    fwbk: "服务板块",
    xzfwbk: "请选择服务板块",
    srfjh: "请输入房间号",
    sdd: "搜地点",
    qhxq: "切换校区",
    srls: "请输入XX楼XX室",
    tpsc: "图片上传",
    wtms: "问题描述",
    mxnyddwtjyj: "描述您遇到的问题及相关意见建议，请您一事一反馈。",
    wjsglbmdhf: "我接受管理部门的回访",
    wbjsglbmdhf: "我不接受管理部门的回访",
    xxndxyglfwgzdzc: "谢谢您对校园管理服务工作的支持！",
    gradutegzdzc: "谢谢您对研究生管理服务工作的支持！",
    qygzzc: "该板块由校学联运营，谢谢您对学生权益工作的支持！",
    nryxsblyk:
      "内容越详实，办理越快速哦！请不要吝啬您的“金点子”,不同类型的事项请分开提交吧!",
    // ViewFeedback
    xyshfwfkxq: "反馈详情",
    xqxx: "详情信息",
    fkdd: "反馈地点",
    fktp: "反馈图片",
    nrms: "内容描述",
    blgc: "办理过程",
    sj: "时间",
    jd: "进度",
    wfbl: "无法办理",
    fkhf: "反馈回复",
    mydpj: "满意度评价",
    my: "满意",
    rk: "认可",
    bmy: "不满意",
    ybj: "已办结",
    fhjc: "复核进程",
    yfh: "已复核",
    hxbljg: "后续办理结果",
    dfsj: "答复时间",
    dbljgjxpj: "请对办理结果进行评价",
    bypj: "不予评价",
    dnlbmy: "对哪里还有不满意呢？",
    msndwt: "请描述你的问题",
    bjft: "办结附图",
    // YouthVoice

    qsrssnr: "请输入你要搜索的内容",
    ss: "搜索",
    zzjz: "正在加载",
    zwsj: "暂无数据",
    xzejfl: "请选择二级分类",
    sfnm: "是否匿名",
    cgtjfk: "你已成功提交意见反馈！",
    ydhb: "月度汇报",
    jzwc: "加载完成",
    yjddl: "已经到底了",
    xzxydfw: "请选择想要评价的服务",
    shi: "食",
    zhu: "住",
    xing: "行",
    shang: "商",
    yi: "医",
    jiaoshi: "教室",
    ecmyd: "二次满意度",
    zx: "咨询",
    ts: "投诉",
    jy: "建议",
    dz: "点赞",
    zxgg: "最新公告",
    mygd: "没有更多了",
    fb: "发布",
    xxwc: "拾取者与失主已经于线下自行完成归还，如有疑问可以与拾取者进行联系。",
    ssgjchtgxgh: "搜索关键词或通过学工号找卡",
    ssgjc: "搜索关键词（多个关键词用空格隔开）",
    mzsm: "免责声明",
    zhsj: "找回时间",
    sc: "删除",
    bj: "编辑",
    sjhm: "手机号码",
    yzm: "验证码",
    ycctj: "你已成功提交意见反馈！",
    ecpjmyd: "二次评价满意度",
    xysqsjh:
      "您预留的个人信息可能会被管理单位查阅但不会被公开。若您有其他特殊需求，可在反馈时一并说明或致电54741234"
  }
};

// WEBPACK FOOTER //
// ./src/components/lang/zh.js



// WEBPACK FOOTER //
// ./src/components/lang/zh.js